<template>
  <div class="pet-health">
    <div class="title">ペット体調管理</div>

    <!-- 登録ダイアログ -->
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="検査日付" prop="kensaDate">
          <el-date-picker
            v-model="form.kensaDate"
            type="date"
            placeholder="1900/01/01"
            format="yyyy/MM/dd"
            value-format="yyyy/MM/dd"
            :disabled="showMode === 2">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="病院名前" prop="biyouinName">
          <el-input v-model="form.biyouinName" placeholder="256桁以内" maxlength="256" :disabled="showMode === 2"></el-input>
        </el-form-item>

        <el-form-item label="検査内容" prop="kensaNaiyo">
          <el-input
            type="textarea"
            v-model="form.kensaNaiyo"
            placeholder="256桁以内"
            maxlength="256"
            :rows="4"
            :disabled="showMode === 2">
          </el-input>
        </el-form-item>

        <el-form-item label="狂犬注射日" prop="kyokenbiyoDate">
          <el-date-picker
            v-model="form.kyokenbiyoDate"
            type="date"
            placeholder="1900/01/01"
            format="yyyy/MM/dd"
            value-format="yyyy/MM/dd"
            :disabled="showMode === 2">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="ワクチン名" prop="wakuchiName">
          <el-input v-model="form.wakuchiName" placeholder="256桁以内"  maxlength="256" :disabled="showMode === 2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="savePetHealthInfo()">　保　存　</el-button>
        <el-button v-if="showMode !== 1" type="success" @click="editPetHealthInfo()">　編　集　</el-button>
        <el-button v-if="showMode !== 1" type="danger" @click="deletePetHealthInfo()">　削　除　</el-button>
      </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { Message, MessageBox } from 'element-ui';

export default {
  name: 'PetHealth',
  data() {
    return {
      showMode:'', // 1:新規登録 2:更新(読込専用) 3:更新(編集可)
      // フォーム
      form: {
        kusuriTechoSeq: this.$route.query.kusuriTechoSeq,
        petSeq: this.$route.query.petSeq,
        kensaDate: '',
        biyouinName: '',
        kensaNaiyo: '',
        kyokenbiyoDate: '',
        wakuchiName: '',
      },
      // バリデーションルール
      rules: {
        kensaDate: [
          { required: true, message: '必須です。', trigger: 'blur' }
        ],
        biyouinName: [
          { required: true, message: '必須です。', trigger: 'blur' }
        ],
        kensaNaiyo: [
          { required: true, message: '必須です。', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 更新 or 新規判定
    if (this.form.kusuriTechoSeq) {
      this.showMode = 2; // 更新(読込専用)
      this.getPetHealthInfo();
    } else {
      this.showMode = 1; // 新規登録
    }

  },
  methods: {
    // 初期処理
    getPetHealthInfo() {
      request('getPetHealthInfo', this.form.kusuriTechoSeq).then((res) => {
        Object.assign(this.form, res.kusuriTecho);
      });  
    },
    // 保存
    savePetHealthInfo() {
      request('savePetHealthInfo', this.form).then((res) => {
        Message.success(res.msg);
        this.goMyPetHome();
      });  
    },
    // 編集
    editPetHealthInfo() {
      this.showMode = 3; // 更新(編集可)
    },
    // 削除
    deletePetHealthInfo() {
      MessageBox.confirm(`削除してもよろしいでしょうか？`, '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(() => {
        request('deletePetHealthInfo', this.form.kusuriTechoSeq).then((res) => {
          Message.success(res.msg);
          this.goMyPetHome();
        });  
      });
    },
    goMyPetHome() {
      this.$router.push({
        path: '/myPetHome',
        query: { petSeq: this.form.petSeq }
      }).catch(() => {});
    },
  }
}
</script>

<style lang="less" scoped>
.pet-health {
  padding: 20px;

  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 30px;
    text-align: center;
  }

  .search-form {
    margin-bottom: 20px;
  }
}
</style>